var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"close-icon float-right",class:_vm.iconColor,attrs:{"id":_vm.id,"title":_vm.$t('btnCloseLabel')},on:{"click":_vm.$_onClose}})])
}
var staticRenderFns = []

export { render, staticRenderFns }